import React, { useState, useRef, useEffect } from 'react';
import { Modal, Box, Typography, Button, Link, useTheme, useMediaQuery } from '@mui/material';
import FormCheckbox from 'qubCommon/Inputs/Checkbox';
import { Check } from '@mui/icons-material';
import { useFormContext } from 'react-hook-form';

const Waiver = (props) => {
    const { title, name, label, content, onAgree, defaultValue } = props;
    const [open, setOpen] = useState(false);
    const [checked, setChecked] = useState(defaultValue);
    const [canCheck, setCanCheck] = useState(false);
    const scrollRef = useRef(null);
    const form = useFormContext();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Detect mobile screens

    useEffect(() => {
        form.setValue(name, defaultValue);
    }, [defaultValue]);

    // Open Modal
    const handleOpen = () => {
        setOpen(true);
        setChecked(false); // Reset checkbox when reopening
        setCanCheck(false); // Reset scroll check when reopening
    };

    // Close Modal
    const handleClose = () => {
        setOpen(false);
    };

    // Handle Scroll Event
    const handleScroll = () => {
        if (scrollRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
            if (scrollTop + clientHeight >= scrollHeight - 10) {
                setCanCheck(true);
            }
        }
    };

    // Check if the content is scrollable AFTER the modal fully opens
    useEffect(() => {
        if (open) {
            setTimeout(() => {
                if (scrollRef.current) {
                    const { scrollHeight, clientHeight } = scrollRef.current;
                    if (scrollHeight <= clientHeight) {
                        setCanCheck(true); // Enable checkbox immediately if not scrollable
                    }
                }
            }, 100);
        }
    }, [open]);

    const handlePrintContent = () => {
        console.log(scrollRef, 'Mello');
        if (!scrollRef.current) return;

        const content = scrollRef.current.innerHTML;
        const win = window.open('', '', 'height=800,width=800');

        if (win) {
            win.document.write('<html><head><title>Print</title></head><body>');
            win.document.write(content);
            win.document.write('</body></html>');
            win.document.close();
            win.focus();
            win.print();
            win.close();
        }
    };

    const handleDownload = () => {
        const iframe = scrollRef.current?.querySelector('iframe');
        if (iframe) {
            handlePrintIframe();
        } else {
            handlePrintContent();
        }
    };

    const handlePrintIframe = () => {
        const iframe = scrollRef.current?.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        }
    };

    return (
        <div>
            {/* Hyperlink to open modal */}
            <Link component="button" variant="body2" onClick={handleOpen}>
                {title}
            </Link>
            {form?.watch(name) && <Check sx={{ marginBottom: 1, marginLeft: 1 }} color="success" />}

            {/* Modal */}
            <Modal open={open} onClose={handleClose}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        width: '90vw', // Make width responsive
                        maxWidth: isMobile ? '95vw' : 1200, // Limit width based on screen size
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 3,
                        borderRadius: 2,
                        maxHeight: '90vh', // Prevent overflow on mobile
                        overflow: 'auto'
                    }}
                >
                    <Typography variant="h5" gutterBottom align="center">
                        {' '}
                        {/* Reduce font size on mobile */}
                        {title}
                    </Typography>

                    {/* Scrollable Content */}
                    <Box
                        ref={scrollRef}
                        onScroll={handleScroll}
                        sx={{
                            height: isMobile ? '50vh' : '70vh', // Reduce height on mobile
                            overflowY: 'auto',
                            border: '1px solid #ccc',
                            padding: '10px',
                            width: '100%', // Responsive width
                            maxWidth: '100%'
                        }}
                    >
                        {content}
                    </Box>

                    {/* Checkbox */}
                    <FormCheckbox name={name} label={label} disabled={!canCheck} defaultValue={defaultValue} />

                    {/* Close Button */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                        <Button variant="contained" sx={{ mr: 1 }} color="primary" onClick={handleDownload}>
                            Download/Print
                        </Button>
                        <Button variant="contained" color="error" onClick={handleClose}>
                            Close
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

export default Waiver;
